export default __webpack_public_path__ + "static/media/01.16fdaad9.jpg";